import { create } from 'zustand';
import { trackEvent } from '../utils/tracking';
import { trackPlansModalOpened } from '../utils/mixpanel';

// Global UI/client state (modals, panels) lives here so any component can drive
// it without prop-drilling or a dedicated React context per widget.
export const useUIStore = create((set) => ({
  plansModalOpen: false,
  openPlansModal: () => {
    trackEvent('pricing_modal_opened');
    trackPlansModalOpened('global');
    set({ plansModalOpen: true });
  },
  closePlansModal: () => set({ plansModalOpen: false }),
  setPlansModalOpen: (open) => set({ plansModalOpen: open }),
}));
